<template>
  <div class="team-dialog">
    <el-dialog
      :title="dialogTitle"
      :visible="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :before-close="handleClose"
      width="760px"
    >
      <div class="content">
        <el-form size="small" inline>
          <el-form-item label="孵化组名称：">
            <el-input v-model.trim="incubateName" maxlength="10" placeholder="请输入孵化组名称" />
          </el-form-item>
        </el-form>
        <div class="content">
          <p class="content-title">添加队员</p>
          <el-form inline size="small">
            <el-form-item label="手机号查询：">
              <el-input v-model="salePhone" placeholder="请输入手机号码" clearable />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :disabled="!canAdd || loading" @click="handleAddMember">添加</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div class="table">
          <el-table v-loading="loading" :data="membersList" style="width: 100%" size="small" border max-height="460">
            <el-table-column label="姓名" prop="saleName" align="center" />
            <el-table-column label="手机号" prop="salePhone" align="center" />
            <el-table-column label="设为队长" prop="isLeader" align="center">
              <template v-slot="{ row, $index }">
                <el-checkbox :value="row.isLeader" @change="handleLeaderChange(row, $index)" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template v-slot="{ row }">
                <el-button type="text" @click="handleRemove(row)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div slot="footer">
        <el-button size="small" @click="handleClose">取消</el-button>
        <el-button size="small" type="primary" @click="handleNext">下一步</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="确认生效时间"
      width="360px"
      :visible.sync="nextDialogVisable"
      :modal="false"
      :close-on-click-modal="false"
      :before-close="handleCloseConfirm"
    >
      <el-form :model="confirmForm" ref="confirmForm" size="small" inline>
        <el-form-item
          label="生效时间: "
          prop="operateDate"
          :rules="[{ required: true, message: '请选择生效时间', trigger: 'change' }]"
        >
          <el-date-picker
            v-model="confirmForm.operateDate"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="请选择生效时间"
            :picker-options="pickerOptions"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="handleCloseConfirm">取消</el-button>
        <el-button :loading="process" type="primary" size="small" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getGroupSale, getSale, operateBaseIncubate, addBaseIncubateSale } from '@/api/incubator/index.js'
import dayjs from 'dayjs'

export default {
  name: 'GroupManage',

  data() {
    return {
      dialogVisible: false,
      incubateId: '',
      incubateName: '',
      salePhone: '',
      loading: false,
      membersList: [],
      nextDialogVisable: false,
      confirmForm: {
        operateDate: '',
      },
      pickerOptions: {
        disabledDate(time) {
          return dayjs(time).isAfter(dayjs(), 'day')
        }
      },
      process: false
    };
  },
  computed: {
    dialogTitle () {
      return this.incubateId ? '编辑孵化组' : '添加孵化组'
    },
    canAdd () {
      return /^1[23456789]\d{9}$/.test(this.salePhone)
    }
  },
  methods: {
    init(payload) {
      if (payload) {
        this.incubateId = payload.id
        this.incubateName = payload.incubateName
        this.handleGetGroupSale()
      }
      this.dialogVisible = true
    },
    handleGetGroupSale() {
      const params = {
        incubateId: this.incubateId,
        limit: 9999,
        page: 1
      }
      this.loading = true
      getGroupSale(params).then(({ code, data }) => {
        if (code === 0) {
          this.membersList = data.records.map(item => {
            return {
              ...item,
              isLeader: item.isLeader === 1
            }
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleAddMember() {
      // 判断当前组中是否有重复
      if (this.membersList.some(({ salePhone }) => salePhone === this.salePhone)) {
        this.$message.warning('当前账号已存在组内, 请勿重复添加!')
        return
      }
      // 查询销售
      getSale({ salePhone: this.salePhone }).then(({ code, data }) => {
        if (code === 0 && data.data) {
          const v = {
            saleId: data.data.saleId,
            saleName: data.data.saleName,
            salePhone: data.data.saleAccount,
            isLeader : false
          }
          if (data.code === 2) {
            this.$confirm('当前账号已存在其他组内，确认添加将从原组内移除?', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            })
              .then(() => {
                this.membersList.push(v)
              })
              .catch(() => {});
          } else {
            this.membersList.push(v)
          }
        } else if (data.code === 1) {
          this.$message.warning('未查询到此号码的员工信息!')
        }
      })
    },
    handleLeaderChange(row, index) {
      this.membersList.splice(index, 1, {
        ...row,
        isLeader: !row.isLeader
      })
    },
    handleRemove(rowData) {
      this.membersList = this.membersList.filter(
        (item) => item.saleId !== rowData.saleId
      )
    },
    handleNext() {
      if (!this.incubateName) {
        this.$message.warning('请输入孵化组名称!')
        return
      }
      this.nextDialogVisable = true
    },
    // 确认时间
    handleSubmit() {
      this.$refs.confirmForm.validate(valid => {
        if (valid) {
          // 创建 or 编辑孵化组
          const params = {
            incubateName: this.incubateName,
            effectDate: this.confirmForm.operateDate
          }
          if (this.incubateId) {
            params.id = this.incubateId
          }
          this.process = true
          // 创建 or 编辑孵化组
          operateBaseIncubate(params).then(({ code, data }) => {
            if (code === 0) {
              // 关联组员
              if (this.membersList.length !== 0) {
                if (!this.incubateId && !data) {
                  this.$message.error('没有有效ID, 请联系管理员')
                  return
                }
                const arr = this.membersList.map(item => {
                  return {
                    saleId: item.saleId,
                    saleName: item.saleName,
                    salePhone: item.salePhone,
                    isLeader: item.isLeader ? 1 : 2
                  }
                })
                const params = {
                  incubateId: this.incubateId || data,
                  operateDate: this.confirmForm.operateDate,
                  saleArr: JSON.stringify(arr)
                }
                addBaseIncubateSale(params).then(({ code: s }) => {
                  if (s === 0) {
                    this.$message.success(`${this.dialogTitle}成功!`)
                    this.handleCloseConfirm()
                    this.handleClose()
                    this.$emit('refresh')
                  }
                })
              } else {
                this.$message.success(`${this.dialogTitle}成功!`)
              }
            } else {
              this.process = false
            }
          })
        }
      })
    },
    handleClose() {
      this.operateDate = ''
      this.incubateId = ''
      this.incubateName = ''
      this.salePhone = ''
      this.membersList = []
      this.process = false
      this.dialogVisible = false
    },
    handleCloseConfirm() {
      this.confirmForm.operateDate = ''
      this.$refs.confirmForm.resetFields()
      this.nextDialogVisable = false
    }
  },
};
</script>
<style lang="scss" scoped>
.content-title {
  margin: 12px 0;
  padding-left: 12px;
  font-weight: bold;
  font-size: 16px;
  color: #333;
  position: relative;
  &::before {
    display: block;
    content: '';
    width: 4px;
    height: 20px;
    background-color: #409EFF;
    border-radius: 2px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
